module.exports = __webpack_public_path__ + "fonts/avenir_roman.c6d37b26.ttf";